import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import * as Yup from 'yup';

import { injectIntl } from 'react-intl';
import { Field, Form, Formik } from 'formik';
import { useSelector } from 'react-redux';
import { FormServiceContext } from 'app/utils/contexts';
import { validatePassengersByVehicle } from 'app/utils/forms/validators/license';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import notification from 'app/config/notification';

import { verifyLicencaNameAndFormat } from 'app/utils/forms/services/licenses';

const DialogPassengersSelection = (props) => {
    const { open, handleCancel, handleSave, selectedPerson } = props;

    const validationSchema = Yup.object().shape({
        deNome: Yup.string().required('Campo obrigatório'),
        deRg: Yup.number().typeError('Apenas números são permitidos').required('Campo obrigatório'),
    });

    const onCancel = (e, reason) => {
        if (reason && reason === 'backdropClick') return;
        if (handleCancel) handleCancel(e);
    };

    return (
        <Dialog disableEscapeKeyDown open={open} onClose={onCancel}>
            <DialogTitle>Informe os dados do passageiro</DialogTitle>
            <Formik
                enableReinitialize={true}
                initialValues={{ deNome: '', deRg: '' }}
                validationSchema={validationSchema}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={() => {}}>
                {(formProps) => {
                    const { errors } = formProps;
                    return (
                        <Form>
                            <DialogContent style={{ paddingTop: '0px', maxWidth: '350px' }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Field
                                            label="Nome completo"
                                            variant="filled"
                                            margin="dense"
                                            fullWidth
                                            name="deNome"
                                            error={!!errors.deNome}
                                            helperText={errors.deNome ? errors.deNome : ''}
                                            as={TextField}
                                            inputProps={{
                                                maxLength: 100,
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            label="RG"
                                            variant="filled"
                                            margin="dense"
                                            fullWidth
                                            name="deRg"
                                            error={!!errors.deRg}
                                            helperText={errors.deRg ? errors.deRg : ''}
                                            as={TextField}
                                            inputProps={{
                                                maxLength: 10,
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => handleCancel()} color="primary">
                                    Cancelar
                                </Button>
                                <Button
                                    onClick={() => {
                                        formProps.validateForm().then((res) => {
                                            if (Object.keys(res).length <= 0) {
                                                handleSave(formProps.values, selectedPerson);
                                            }
                                        });
                                    }}
                                    color="primary">
                                    Salvar
                                </Button>
                            </DialogActions>
                        </Form>
                    );
                }}
            </Formik>
        </Dialog>
    );
};

function Passengers(props) {
    const { classes, data, setData, intl } = props;
    const { canEdit, errorsList, setErrorsList } = useContext(FormServiceContext);
    const [open, setOpen] = React.useState(false);
    const [selectedPerson, setSelectedPerson] = useState(null);
    const [filteredCollectionData, setFilteredCollectionData] = useState({
        dataBoExcluido: [],
        dataBoNotExcluido: [],
    });

    const selectedVehicles = useSelector((state) => state.vehicle.selectedVehicles);

    useEffect(() => {
        const init = () => {
            const temp = _.cloneDeep(data);
            const dataBoExcluido = temp.filter((c) => c.boExcluido);
            const dataBoNotExcluido = temp.filter((c) => !c.boExcluido);
            setFilteredCollectionData({
                dataBoExcluido,
                dataBoNotExcluido,
            });
        };
        init();
    }, [data]);

    const changeElement = async (index) => {
        let temp = [...data];
        if (index === undefined) {
            //add

            if (selectedVehicles.length > 0) {
                if (!validatePassengersByVehicle(selectedVehicles, temp)) {
                    return;
                }
            }
            handleClickOpen(temp.length);
        } else {
            if (window.confirm('Deseja excluir este item?')) {
                temp = verifyLicencaNameAndFormat({
                    filteredCollectionData,
                    index,
                    cdLicencaName: 'cdLicencaPassageiro',
                });
            }
        }
        setData(temp);
    };

    const handleClickOpen = (index) => {
        setSelectedPerson(index);
        setOpen(true);
    };

    const handleCancel = () => {
        setSelectedPerson(null);
        setOpen(false);
    };

    // save
    const onChangeField = (passenger) => {
        if (errorsList && errorsList.passengers) {
            const errorsTemp = { ...errorsList };
            delete errorsTemp.passengers;

            setErrorsList(errorsTemp);

            return;
        }

        let temp = _.cloneDeep(data);
        const { dataBoExcluido, dataBoNotExcluido } = filteredCollectionData;
        const indexLastPassenger = dataBoNotExcluido.length - 1;

        const foundOnList = _.find(dataBoNotExcluido, function (o) {
            return o.deRg === passenger.deRg;
        });

        if (foundOnList) {
            notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.ELEMENT_ALREADY_EXISTS' }), {
                toastId: 'ELEMENT_ALREADY_EXISTS',
                type: 'warning',
            });
            return false;
        }

        dataBoNotExcluido[indexLastPassenger + 1] = passenger;

        temp = [...dataBoNotExcluido, ...dataBoExcluido];

        setData(temp);
        handleCancel();
        return true;
    };

    return (
        <>
            <DialogPassengersSelection
                {...props}
                selectedPerson={selectedPerson}
                open={open}
                handleCancel={handleCancel}
                handleSave={onChangeField}
                classes={classes}
            />

            <Grid item xs={12}>
                <h3 className={classes.titleTable}>Passageiros</h3>
                <Table className={errorsList?.passengers ? classes.tableError : classes.table}>
                    <TableHead>
                        <TableRow className={classes.tableRow}>
                            <TableCell className={classes.headTableCell} align="left">
                                Nome completo
                            </TableCell>
                            <TableCell className={classes.headTableCell} align="left">
                                RG
                            </TableCell>
                            {canEdit && (
                                <TableCell className={classes.headTableCell} align="center">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disableElevation
                                        onClick={() => changeElement()}
                                        className={classes.addButton}>
                                        <AddIcon /> Adicionar
                                    </Button>
                                </TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredCollectionData.dataBoNotExcluido.map((row, indexRow) => (
                            <TableRow key={`irr-row-${indexRow}`} className={classes.tableRow}>
                                <TableCell align="left">{row.deNome || ''}</TableCell>
                                <TableCell align="left">{row.deRg || ''}</TableCell>
                                {canEdit && (
                                    <TableCell align="right">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => changeElement(indexRow)}
                                            className={classes.btnSigleAction}
                                            size="small">
                                            <DeleteIcon fontSize="inherit" />
                                        </Button>
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
        </>
    );
}

export default injectIntl(Passengers);
